'use strict';
// Replacement of tabs/pane (from angular-ui's' ui-bootstrap.tpls.js) that emits an event on tab selection
angular.module('ui.bootstrap.tabs')
    .directive('enhancedTabs', function () {
    return {
        restrict: 'E',
        transclude: true,
        scope: {},
        controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
                $scope.panes = [];
                var panes = $scope.panes;
                $scope.select = function (pane) {
                    angular.forEach(panes, function (pane) {
                        pane.selected = false;
                    });
                    pane.selected = true;
                    //logger.debug('tabChanged heading: ' + pane.heading);
                    //logger.debug('tabChanged id: ' + pane.id);
                    if (typeof pane.id !== 'undefined' && pane.id !== null) {
                        $rootScope.$broadcast("tabChanged", pane.id);
                    }
                };
                this.addPane = function (pane) {
                    if (panes.length === 0) {
                        $scope.select(pane);
                    }
                    panes.push(pane);
                };
            }],
        template: '<div class="tabbable">' +
            '<ul class="nav nav-tabs">' +
            '<li ng-repeat="pane in panes" ng-class="{active:pane.selected}" ng-hide="pane.panehide">' +
            '<a href="" ng-click="select(pane)">{{pane.heading}}</a>' +
            '</li>' +
            '</ul>' +
            '<div class="tab-content" ng-transclude></div>' +
            '</div>',
        replace: true
    };
});
angular.module('ui.bootstrap.tabs')
    .directive('enhancedPane', function () {
    return {
        require: '^enhancedTabs',
        restrict: 'E',
        transclude: true,
        //scope:{ heading:'bind' },
        scope: { heading: '@', id: '@', panehide: '@', panecontroller: '&' },
        link: function (scope, element, attrs, tabsCtrl) {
            tabsCtrl.addPane(scope);
        },
        template: '<div class="tab-pane" ng-class="{active: selected}" ng-transclude></div>',
        replace: true
    };
});
//# sourceMappingURL=bootstrap-custom.directives.js.map